import { createReducer, on } from '@ngrx/store';
import {
  DeleteNotificationContentAction,
  DeleteNotificationContentErroredAction,
  DeleteNotificationContentSucceededAction,
  NotificationContentErrorTimedOutAction,
  NotificationContentFilterChangedAction,
  NotificationContentLoadAction,
  NotificationContentLoadErroredAction,
  NotificationContentLoadSucceededAction,
  NotificationContentPaginationChangedAction,
  NotificationContentSortChangedAction,
  PublishNotificationContentAction,
  PublishNotificationContentErroredAction,
  PublishNotificationContentSucceededAction,
} from './notification-content.actions';
import { NotificationContentState } from './types';

const initialState: NotificationContentState = {
  ids: [],
  entities: {},
  sort: { sortOrder: 'desc', orderBy: 'datetimeModified' },
  pagination: { limit: 10, page: 1, total: 0 },
  filter: null,
  loaded: false,
  apiError: null,
};

const defaultPagination = (state: NotificationContentState) => ({
  limit: state.pagination.limit,
  page: 1,
  total: 0,
});

export const notificationContentReducer = createReducer(
  initialState,
  on(NotificationContentLoadAction, () => ({ ...initialState })),
  on(NotificationContentLoadSucceededAction, (state, { limit, page, total, data }) => {
    const ids = data.map((entity) => entity.id);
    const entities = data.reduce((acc, entity) => ({ ...acc, [entity.id]: entity }), {});

    return {
      ...state,
      ids,
      entities,
      pagination: { limit, page, total },
      loaded: true,
    };
  }),
  on(NotificationContentLoadErroredAction, (state, { apiError }) => ({
    ...state,
    apiError,
    loaded: false,
  })),
  on(NotificationContentSortChangedAction, (state, { sort }) => ({
    ...state,
    sort,
    pagination: defaultPagination(state),
    loaded: false,
  })),
  on(NotificationContentPaginationChangedAction, (state, { pagination }) => ({
    ...state,
    pagination: { ...state.pagination, ...pagination },
    loaded: false,
  })),
  on(NotificationContentFilterChangedAction, (state, { filter }) => ({
    ...state,
    filter,
    pagination: defaultPagination(state),
    loaded: false,
  })),
  on(DeleteNotificationContentAction, PublishNotificationContentAction, (state) => ({
    ...state,
    loaded: false,
  })),
  on(
    DeleteNotificationContentSucceededAction,
    PublishNotificationContentSucceededAction,
    (state) => ({
      ...state,
      loaded: true,
    }),
  ),
  on(
    DeleteNotificationContentErroredAction,
    PublishNotificationContentErroredAction,
    (state, { apiError }) => ({
      ...state,
      apiError,
    }),
  ),
  on(NotificationContentErrorTimedOutAction, (state) => ({
    ...state,
    apiError: null,
  })),
);
